// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eY3Cf","comment":"styles_comment__23tCA"};